import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

export interface IFormMessagesService {
  messages: any;
}

export interface IFormMessageData {
  data?: any;
  form: UntypedFormGroup;
  formErrors: any;
  formMessages: IFormMessagesService;
}

@Injectable()
export class FormMessageBulderService {
  onValueChange(formMessageData: IFormMessageData, validateOnlyDirtyControls: boolean) {
    if (!formMessageData.form) {
      return;
    }

    for (let field in formMessageData.formErrors) {
      formMessageData.formErrors[field] = '';

      const control = formMessageData.form.get(field);
      const onlyDirtyState = validateOnlyDirtyControls ? control.dirty : true;

      if (control && control.invalid && onlyDirtyState) {
        const message = formMessageData.formMessages[field];

        for (let key in control.errors) {
          formMessageData.formErrors[field] += message[key] + ' ';
        }
      }
    }
  }
}
